{
  "aboutSubProject": "About subproject",
  "clusterOperation": "Cluster operation",
  "noActiveClusterOperation": "There is no active cluster operation",
  "previousOperation": "Previous cluster operation"
}
